
import { Vue, Component, Prop } from "vue-property-decorator";
import { queries } from "@/apollo";
import * as legacyApollo from "@/apollo/legacySmartQuery";
import { customMoment } from "@/main";
import { User, DdPage } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { startCase, groupBy } from "lodash";
import PageDetailsModal from "../bet-details/PageDetailsModal.vue";
import { useTranslation } from "@/store/translation";

@Component({
  mixins: [legacyApollo.legacySmartQueries({
    user: {
      query: queries.userPages,
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.userId || !this.value;
      },
      variables() {
        return {
          releaseDateStart: this.releaseDateStart,
          releaseDateEnd: this.releaseDateEnd,
          behalfOf: this.userId
        };
      }
    }
  })],
  components: {
    PageDetailsModal,
  }
})
export default class CopyBetModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) userId!: boolean;
  user = null as null | User;

  selectedPage = null as null | DdPage
  showPageDetailModal = false;

  t = (text: string) => useTranslation().$t(text);

  releaseDateStart = customMoment()
    .add(-3, "weeks")
    .startOf("day")
    .toDate();

  releaseDateEnd = customMoment()
    .startOf("day")
    .toDate();

  startCase = startCase;
  formatCount = formatCount;
  formatDollar = formatDollar;

  get processedPagesByReleaseDate() {
    return Object.entries(groupBy(this.user?.pages, p => p.releaseDate)).sort(([releaseDateA], releaseDateB) => {
      return customMoment(releaseDateB[0]).unix() - customMoment(releaseDateA[0]).unix();
    }).map(([releaseDate, pages]) => {
      // aggregate
      const bigCount = pages.reduce((acc, page) => acc + page.calculation.bigCount, 0);
      const smallCount = pages.reduce((acc, page) => acc + page.calculation.smallCount, 0);
      const rawCost = pages.reduce((acc, page) => acc + page.calculation.rawCost, 0);
      return {
        releaseDate,
        pages,
        agg: {
          bigCount,
          smallCount,
          rawCost
        }
      }
    }).sort((a, b) => {
      return customMoment(b.releaseDate).unix() - customMoment(a.releaseDate).unix();
    });
  }

  toggleModal(val: boolean) {
    this.$emit("input", val);
  }

  openPage(page: DdPage) {
    this.selectedPage = page;
    this.showPageDetailModal = true;
  }

  handleSubmit() {
    this.toggleModal(!this.value);
  }


  reloadAll() {
    legacyApollo.refetchLegacySmartQueries(this);
  }


  formatDatetime(dateStr: string | Date) {
    return customMoment(dateStr).fromNow()
  }
  formatDate(dateStr: string | Date) {
    return customMoment(dateStr).format("DD/MM/YYYY");
  }
  formatReleaseDate(dateStr: string | Date) {
    return customMoment(dateStr).format("ddd, DD/MM/YYYY");
  }

  handleCopy(id: DdPage["id"]) {
    const page = this.user?.pages.find(p => p.id === id);
    if (!page) {
      return;
    }
    this.$emit("copy", page);
    this.toggleModal(false);
    // this.selectedPage = page;
    // this.showPageDetailModal = true;
  }
}
